import MongoModel from './MongoModel'
import { required, string } from 'vue-mc/validation'

export default class CustomField extends MongoModel {
  modelName = 'Custom Field'
  collection = 'custom-fields'
  autoFields = true

  defaults () {
    return {
      id: null,
      organization: null,
      name: null,
      description: null,
      attachedTo: [],
      key: null,
      type: null,
      values: []
    }
  }

  mutations () {
    return {
    }
  }

  validation () {
    return {
      name: string.and(required),
      key: string.and(required)
    }
  }
}
